$(document).ready(async function () {
  await checkPrestiCounter();  
  await formSubmit();
  socialShare();
});

async function checkPrestiCounter(){
  try {
    const resp = await fetch(`https://isotope.howardmiller.com/presti/howardmiller/count`, {
      method: "GET",
      credentials: "include"
    });
    
    if (resp.ok) {
      const data = await resp.json();
      console.log("presti counter", data);
      if (data.presti_counter >= 50) {
        $(".presti-container").hide();
      }
    } else {
      console.error("Failed to check presti counter:", resp.status);
    }
  } catch (err) {
    console.error("Error checking presti counter:", err);
  }
}

async function formSubmit(){
  $("#room-form").on("submit", async function (event) {
    event.preventDefault();

    const selectedRoomInput = $('input[name="room"]:checked').val();
    const selectedFloorInput = $('input[name="floor"]:checked').val();
    const selectedColorInput = $('#room-color').val();
    const mountedTVInput = $('input[name="mounted-tv"]').val();
    const intiaroImage = getIntiaroPlayer("hmc360-viewer").getFrameUrl(0);
    const sku = $('.sku__value').text();
    const configId = window.config_id ?? Date.now();

    var floorInput = selectedFloorInput + " flooring, area rug";
    var mountedTV = `with ${selectedRoomInput} artwork hanging on the wall above it`;

    if ($('#mounted-tv').is(':checked')) {
      var mountedTV = "with a similar sized tv mounted on the wall above it";
    }
    
    if (selectedFloorInput == "carpet") {
      floorInput = selectedFloorInput + " flooring";
    }
    if (selectedRoomInput == "traditional") {
      var prestiPrompt = `entertainment console ${mountedTV} in an elegant ${selectedRoomInput} interior, ${floorInput}, ${selectedColorInput} toned wall`;  
    }
    if (selectedRoomInput == "transitional") {
      var prestiPrompt = `entertainment console ${mountedTV} in an elegant ${selectedRoomInput} interior, ${floorInput}, ${selectedColorInput} toned wall enhanced by crisp white wainscoting`;  
    }
    if (selectedRoomInput == "contemporary") {
      var prestiPrompt = `entertainment console ${mountedTV} in an elegant ${selectedRoomInput} interior, ${floorInput}, ${selectedColorInput} toned wall enhanced by floor to ceiling windows`;  
    }    
    
    console.log(prestiPrompt);

    if (!selectedRoomInput.length) {
      alert("Please select a room style first.");
      return;
    }

    $("#presti-loading-message").show();
    $(".presti-form-container").hide();
    startPdfProgressBar();

    try {
      const payload = {
        roomStyle: selectedRoomInput,
        floorStyle: selectedFloorInput,
        colorStyle: selectedColorInput,
        prestiPrompt: prestiPrompt,
        image: intiaroImage,
        sku: sku,
        configId: configId
      };

      const submitResponse = await fetch("https://isotope.howardmiller.com/presti_room_generator", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
        credentials: "include",
        //timeout: 60000 // 60 second timeout
      });

      if (!submitResponse.ok) {
        throw new Error(`HTTP error! status: ${submitResponse.status}`);
      }

      const responseData = await submitResponse.json();

      if (responseData.imageUrl) {
        $("#presti-result-image").attr("src", responseData.imageUrl);
        //$(".share-presti-image-container").show();
      
        // Increment presti counter
        try {
          await fetch(`https://isotope.howardmiller.com/presti/howardmiller/increment`, {
            method: "POST",
            credentials: "include"
          });
        } catch (err) {
          console.error("Error incrementing presti counter:", err);
        }
      } else {
        throw new Error("No image URL in response");
      }

    } catch (error) {
      console.error("Error:", error);
      alert("Failed to generate room image. Please try again.");
    } finally {
      $("#presti-loading-message").hide();
    }
  });
}

function startPdfProgressBar() {
  const $container = $(".progress-container");
  const $progressBar = $("#progress-bar");

  $container.show();
  $progressBar.css("width", "0%");
  $progressBar[0].offsetWidth;
  $progressBar.css({
    transition: "width 45s linear",
    width: "100%",
  });

  setTimeout(function () {
    $progressBar.css({
      transition: "none",
      width: "0%",
    });
    console.log($(".pdf-error").length);
    if ($(".pdf-error").length == 0) {
      $container.hide();
    }
    //console.log("Container Width: ", $progressBar.css(width));
  }, 45000);
}

function socialShare(){
  let $shareBtn = $('#share-image-btn');
  let $options = $('#share-options');
  let $image = $('#presti-result-image');
  let $feedback = $('#share-feedback');
  let pageUrl = window.location.href;
  let imageDataUrl = $image.attr('src');

  $shareBtn.on('click', function() {
    if (navigator.canShare && window.File && imageDataUrl.startsWith('data:image')) {
      fetch(imageDataUrl)
        .then(function(res) { return res.blob(); })
        .then(function(blob) {
          var file = new File([blob], 'shared-image.png', { type: blob.type });
          if (navigator.canShare({ files: [file] })) {
            navigator.share({
              files: [file],
              title: document.title || 'Check this image!',
              text: 'Check out this image!',
              url: pageUrl
            }).catch(function() {
              $options.show();
            });
            return;
          } else {
            $options.show();
          }
        })
        .catch(function() {
          $options.show();
        });
    } else {
      // Fallback
      $options.show();
    }
  });

  $options.on("click", ".share-option", function () {
    var platform = $(this).data("platform");
    var shareUrl;
    $feedback.hide();

    switch (platform) {
      case "facebook":
        shareUrl = "https://www.facebook.com/sharer/sharer.php?u=" + encodeURIComponent(pageUrl);
        window.open(shareUrl, "_blank", "width=600,height=400");
        break;
      case "twitter":
        shareUrl =
          "https://twitter.com/intent/tweet?url=" +
          encodeURIComponent(pageUrl) +
          "&text=" +
          encodeURIComponent("Check out this image!");
        window.open(shareUrl, "_blank", "width=600,height=400");
        break;
      case "pinterest":
        shareUrl =
          "https://pinterest.com/pin/create/button/?url=" +
          encodeURIComponent(pageUrl) +
          "&media=" +
          encodeURIComponent(imageDataUrl) +
          "&description=" +
          encodeURIComponent("Check out this image!");
        window.open(shareUrl, "_blank", "width=600,height=400");
        break;
      case "download":
        var link = document.createElement("a");
        link.href = imageDataUrl;
        link.download = "shared-image.png";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        $feedback.text("Image downloaded!").show();
        break;
      case "copy":
        fetch(imageDataUrl)
          .then(function (res) {
            return res.blob();
          })
          .then(function (blob) {
            var item = new ClipboardItem({ [blob.type]: blob });
            navigator.clipboard.write([item]).then(
              function () {
                $feedback.text("Image copied to clipboard!").show();
              },
              function () {
                $feedback.text("Copy failed. Try downloading instead.").show();
              }
            );
          });
        break;
      default:
        $options.hide();
    }
  });   
}